<template>
  <div class="star-top">
    <div class="star-top-bg">
      <div
        v-show="!topBg"
        class="star-top-bg-default"
      />
      <div
        v-show="topBg && searchData.detail.sogou_image"
        class="star-top-bg-img"
      >
        <img
          :src="searchData.detail.sogou_image"
          @error="bgError()"
        >
        <div class="star-top-bg-img-after" />
      </div>
    </div>
    <TopHead :title="'明星'" />
    <div class="star-top-content">
      <div
        v-show="topBg && searchData.detail.sogou_image"
        class="star-top-content-img"
      >
        <CoverImage
          :src="searchData.detail.sogou_image"
          :is-resize="false"
        />
      </div>
      <div class="star-top-content-info">
        <h3 class="star-name">
          {{ searchData.star }}
        </h3>
        <div v-if="searchData.detail">
          <p v-if="searchData.detail.work">
            职业：{{ searchData.detail.work.join(' ') }}
          </p>
          <p v-if="searchData.detail.birthDate">
            生日：{{ searchData.detail.birthDate }}
          </p>
          <p v-if="searchData.detail.birth_place">
            地区：{{ searchData.detail.birth_place }}
          </p>
        </div>
      </div>
    </div>
    <div class="star-bottom" />
    <div class="star-top-nav">
      <div class="star-top-nav-box">
        <a
          v-for="(item, index) in searchData.entity"
          :key="index"
          :class="item.doctype === starTab ? 'cur' : ''"
          @click="changeStarWorks(item, index)"
        >
          {{ item.doctypeName }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import TopHead from '../../common/components/TopHead.vue';
import { singlePageClParams } from '../../common/js/util';
import CoverImage from './CoverImage.vue';

export default {
  components: {
    TopHead,
    CoverImage,
  },
  data() {
    return {
      topBg: true,
    };
  },
  computed: {
    ...mapState('star', ['searchData', 'starTab']),
  },
  updated() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.querySelectorAll('.star-top-nav-box .cur')[0].scrollIntoView({
      block: 'end',
      inline: 'center',
    });
  },
  methods: {
    changeStarWorks(item) {
      const { query } = this.$router.history.current;
      query.starTab = item.doctype;
      const { path } = this.$router.history.current;
      const qArr = [];

      Object.keys(query).forEach((key) => {
        if (query[key]) {
          qArr.push(`${key}=${encodeURIComponent(query[key])}`);
        }
      });
      const url = `${path}?${qArr.join('&')}`;
      const clParams = singlePageClParams(`nav_${query.starTab}&href=${url}`);
      this.$uigs.send(clParams);
      location.href = url;
    },
    bgError() {
      this.topBg = false;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_search.scss';

.star-top {
  overflow: hidden;
  position: relative;
  .star-top-bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
    .star-top-bg-default {
      position: absolute;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-image: url('../../../asset/img/mingxing-bg.png');
    }
    .star-top-bg-img {
      position: relative;
      width: 100%;
      height: 100%;
      filter: blur(100px);
      transform: translateZ(0);
      img {
        width: 100%;
        height: 100%;
      }
      .star-top-bg-img-after {
        position: absolute;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 0px 0px 5px 5px;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
.star-top-content {
  display: flex;
  padding: 0 14px 25px;
  .star-top-content-img {
    width: 23.5%;
    padding-top: 29%;
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 12px;
    z-index: 1;
    border-radius: 5px;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .star-top-content-info {
    z-index: 1;
    overflow: hidden;
    .star-name {
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: normal;
      white-space: nowrap;
      font-size: 22px;
      font-weight: bold;
      line-height: 34px;
      color: rgba(255, 255, 255, 1);
    }
    p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 13px;
      line-height: 19px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: normal;
      white-space: nowrap;
    }
  }
}
.star-bottom {
  width: 100%;
  height: 16px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;
  bottom: 0;
  z-index: 1;
  margin-bottom: -1px;
}
.star-top-nav {
  height: 40px;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
  .star-top-nav-box {
    height: 60px;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
  }
  a {
    display: inline-block;
    padding-left: 15px;
    padding-right: 15px;
    font-size: 17px;
    font-weight: normal;
    color: rgba(85, 85, 85, 1);
    line-height: 25px;
    padding-bottom: 15px;
  }
  .cur {
    font-size: 17px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 25px;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      width: 40%;
      height: 2px;
      border-radius: 1px;
      background-color: #000;
      bottom: 0px;
      left: 30%;
    }
  }
}
</style>
